<template>
  <div class="mt-3">
    <b-button
      v-if="isVisible"
      variant="gray"
      class="f-110 back-to-top-circle py-0"
      @click="backToTop"
    >
      <fa icon="angle-up" />
    </b-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      position: { y: 0 }
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.position.y / document.body.scrollHeight > 0.2;
      }
    }
  },
  created() {
    if (!this.$isServer) {
      this._scrollListener = () => {
        this.position = {
          y: Math.round(window.pageYOffset)
        };
      };
      this._scrollListener();
      window.addEventListener('scroll', this._scrollListener);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._scrollListener);
  },
  methods: {
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style scoped>
.back-to-top-circle {
  width: 34px;
  height: 34px;
}
</style>
